<div class="footer-container">
  <div class="first">
    <img class="logo" src="/assets/images/common/logo-idea.svg" alt="eyesNroad logo">
    <nav>
      <div class="option" [routerLink]="platformLink" [innerHTML]="'footer_Data1' | i18n"></div>
      <div class="option" [routerLink]="contactLink" [innerHTML]="'footer_Data2' | i18n"></div>
    </nav>
    <div class="auth">
      <button class="btn register" [routerLink]="registerLink" [innerHTML]="'footer_Data3' | i18n"></button>
      <button class="btn login" [routerLink]="loginLink" [innerHTML]="'footer_Data4' | i18n"></button>
    </div>
    <ng-container *ngIf="!isLandscape; else landscapeSection">
      <section>
        <div class="row">
          <div [routerLink]="privacyLink" class="privacy" [innerHTML]="'footer_Data5' | i18n"></div>
          <div [routerLink]="hiringLink" class="hiring" [innerHTML]="'footer_Data6' | i18n"></div>
        </div>
        <div class="row">
          <div [routerLink]="tosLink" class="tos" [innerHTML]="'footer_Data7' | i18n"></div>
          <div [routerLink]="cookiesLink" class="cookies" [innerHTML]="'footer_Data8' | i18n"></div>
          <div [routerLink]="privacyLink" class="priv" [innerHTML]="'footer_Data9' | i18n"></div>
        </div>
      </section>
    </ng-container>
    <ng-template #landscapeSection>
      <section>
        <div [routerLink]="tosLink" class="tos" [innerHTML]="'footer_Data11' | i18n"></div>
        <div [routerLink]="privacyLink" class="cookies" [innerHTML]="'footer_Data12' | i18n"></div>
        <div [routerLink]="cookiesLink" class="priv" [innerHTML]="'footer_Data13' | i18n"></div>
        <div [routerLink]="hiringLink" class="hire" [innerHTML]="'footer_Data14' | i18n"></div>
      </section>
    </ng-template>
  </div>
  <div class="second">
    <div class="social">
      <a href="https://www.instagram.com/eyesnroad/" target="_blank">
        <img src="/assets/images/social/ig-icon.svg" alt="Instagram">
      </a>
      <a href="https://www.youtube.com/channel/UCID-e2P38WyoLsfNelzuv7w" target="_blank">
        <img src="/assets/images/social/yt-icon.svg" alt="Youtube">
      </a>
      <a href="https://www.linkedin.com/showcase/eyesnroad/?originalSubdomain=es" target="_blank">
        <img src="/assets/images/social/linkedin-icon.svg" alt="LinkedIn">
      </a>
    </div>
    <div class="copy" [innerHTML]="'footer_Data10' | i18n :translationModes.INSERT_VALUE : year"></div>
    <!-- <div class="red">
      <img src="/assets/images/footer/gob.svg" alt="Gob">
      <img src="/assets/images/footer/redes.svg" alt="Red">
    </div> -->
  </div>
</div>
